import { Component, Injector } from '@angular/core';
import { GateService } from '../../ve.service';
import { BaseGridComponent } from '../base-grid/base-grid.component';
import { CgpConfirmationDialogService } from '../../../../shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { CgpSnackbarService } from '../../../../shared/cgp-snackbar/cgp-snackbar.service';
import { Validators } from '@angular/forms';

@Component({
  selector: 'app-gates',
  templateUrl: '../base-grid/base-grid.component.html',
})
export class GatesComponent extends BaseGridComponent {

  public descMaxLength: number = null;
  public displayOrderMax: number = null;

  constructor(
    cgpConfirmationDialogService: CgpConfirmationDialogService,
    cgpSnackbarService: CgpSnackbarService,
    service: GateService,
    injector: Injector,
  ) {
    super(cgpConfirmationDialogService, cgpSnackbarService, service, injector);
    this.descMaxLength = 50;
    this.displayOrderMax = 5;
    this.appCardTitle = 'Gates';
    this.path = '/?activeOnly=false';

    this.columns = [
      {
        field: 'Description',
        title: 'Description',
      },
      {
        field: 'GateOrder',
        title: 'Display Order',
        editor: 'number',
        filter: 'numeric'
      },
      {
        field: 'IsActive',
        title: 'Active',
        editor: 'boolean',
        filter: 'boolean'
      },
    ];

    this.editForm = this.formBuilder.group({
      Id: [],
      Description: ['',  Validators.required],
      IsActive: [],
      GateOrder:  ['', Validators.compose([Validators.required, Validators.pattern('[0-9]*'), Validators.max(99999)])],
    });
  }
}
